import { render, staticRenderFns } from "./MyStudent.vue?vue&type=template&id=1783f71d&scoped=true&"
import script from "./MyStudent.vue?vue&type=script&lang=js&"
export * from "./MyStudent.vue?vue&type=script&lang=js&"
import style0 from "./MyStudent.vue?vue&type=style&index=0&id=1783f71d&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1783f71d",
  null
  
)

export default component.exports